var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResourcePlanning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.425,
    height: 20.188,
    viewBox: "0 0 20.425 20.188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-resource-management-4051426",
    transform: "translate(-2.355 -2.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3320",
    "data-name": "Group 3320",
    transform: "translate(2.355 2.076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32187",
    "data-name": "Path 32187",
    d: "M26.389,37.493a1.916,1.916,0,0,0-1.864,1.487H21.884a.246.246,0,0,1-.245-.245V35.748a7.621,7.621,0,0,0,1.459-4.48.339.339,0,0,0-.34-.34h-6.3l-5.744,6.256a7.526,7.526,0,0,0,3.918,1.645,8.044,8.044,0,0,0,.866.048A7.512,7.512,0,0,0,20.45,37.03v1.7a1.435,1.435,0,0,0,1.434,1.434h2.75a1.914,1.914,0,1,0,1.755-2.675Zm0,2.64a.726.726,0,1,1,.726-.726A.726.726,0,0,1,26.389,40.132Z",
    transform: "translate(-7.879 -21.132)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32188",
    "data-name": "Path 32188",
    d: "M30.757,10.48h6.5a.339.339,0,0,0,.34-.34A7.193,7.193,0,0,0,37.4,8.523h.954A1.435,1.435,0,0,0,39.79,7.089V5.81a1.914,1.914,0,1,0-1.188,0V7.089a.246.246,0,0,1-.245.245H37.047l-.029,0a7.191,7.191,0,0,0-1.306-2.046h0a7.226,7.226,0,0,0-5.262-2.34h0a.34.34,0,0,0-.34.34V9.832a.649.649,0,0,0,.649.649ZM39.2,3.266a.726.726,0,1,1-.726.726A.726.726,0,0,1,39.2,3.266Z",
    transform: "translate(-20.685 -2.076)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32189",
    "data-name": "Path 32189",
    d: "M10.353,9.86a.339.339,0,0,0-.34-.34H9.967a7.6,7.6,0,0,0-5.45,12.908l5.836-6.357Z",
    transform: "translate(-2.355 -6.993)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcePlanning);
export default __webpack_public_path__ + "static/media/resource-planning.3d2ac975f207149bc6ac39c5b98fd116.svg";
export { ForwardRef as ReactComponent };